import styled from "styled-components";
import { useState } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

const TimeShareVisualWrapper = styled.div`
  width: 100%;
  max-width: 700px;
  height: 100px;
  padding-right: 15px;
  background-color: #ffffffdf;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  z-index: 3;
  position: sticky;
  position: -webkit-sticky;
  top: -12px;
  transform: translateY(-12px);
`;

export default function TimeShareVisual(props: Props) {
  const { timeShare } = props;

  const barOptions: ApexOptions = {
    chart: {
      type: "bar",
      stacked: true,
      stackType: "100%",
      toolbar: {
        show: false,
      },
      width: "100%",
      height: "100%",
      offsetY: 0,
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150
        },
        dynamicAnimation: {
          enabled: true,
          speed: 500
        }
      }
    },
    colors: [
      "var(--crisis-color)",
      "var(--relationships-color)",
      "var(--lifeSkills-color)",
      "var(--health-color)",
      "var(--additionalNeeds-color)",
      "var(--mentalHealth-color)",
      "var(--trauma-color)",
    ],
    stroke: {
      width: 1,
      colors: ["#fff"],
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "100%",
      },
    },
    xaxis: {
      categories: ["Area"],
      labels: {
        show: false, // Hide x-axis labels
      },
      axisBorder: {
        show: false, // Hide x-axis border
      },
      axisTicks: {
        show: false, // Hide x-axis ticks
      },
    },
    yaxis: {
      show: false,
      labels: {
        show: false, // Hide y-axis labels
      },
      axisBorder: {
        show: false, // Hide y-axis border
      },
      axisTicks: {
        show: false, // Hide y-axis ticks
      },
    },
    legend: {
      show: false, // Hide legend
    },
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
    },
    tooltip: {},
  };

  const unwantedKeys = ['admin', 'personalDevelopment'];

  const seriesData = Object.keys(timeShare)
    .filter(key => !unwantedKeys.includes(key))
    .map((key) => ({
      name: key,
      data: [timeShare[key as keyof typeof timeShare]],
    }));

  return (
    <TimeShareVisualWrapper>
      <Chart
        className="visual-time-share"
        options={barOptions}
        series={seriesData}
        type="bar"
        height={110}
      />
    </TimeShareVisualWrapper>
  );
}

interface Props {
  timeShare: timeShare;
}
